import * as React from "react"
import { ToggleButtons, ToggleOption } from "@digits-shared/DesignSystem/FormElements/ToggleButtons"
import styled from "styled-components"
import { TopActivity } from "src/frontend/components/OS/Shared/Widgets/TopActivities/shared"
import { WideWidgetTitle } from "src/frontend/components/OS/Shared/Widgets/WidgetTitle"

/*
  STYLES
*/

const HighlightsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 32px 0 16px;

  .mobile & {
    margin: 32px 12px 16px;
  }
`

/*
  INTERFACES
*/

interface TopActivitiesSelectorProps {
  activeHighlight: TopActivity
  setActiveHighlight: React.Dispatch<React.SetStateAction<string>>
}

/*
  COMPONENTS
*/

export const TopActivitiesSelector: React.FC<TopActivitiesSelectorProps> = ({
  activeHighlight,
  setActiveHighlight,
}) => (
  <HighlightsContainer>
    <WideWidgetTitle>Highlights</WideWidgetTitle>
    <ToggleButtons defaultValue={activeHighlight} onChange={setActiveHighlight}>
      <ToggleOption value={TopActivity.Largest}>Largest</ToggleOption>
      <ToggleOption value={TopActivity.FastestGrowing}>Growing</ToggleOption>
      <ToggleOption value={TopActivity.FastestShrinking}>Shrinking</ToggleOption>
    </ToggleButtons>
  </HighlightsContainer>
)
